import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import AdminPageTypes from '../views/AdminPageTypes';

const State = new Record({
    currentPage: '',
});

class LojaStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.CHOOSE_MENU_FINISH:
                if (action.menu === AdminPageTypes.VENDA_CAIXA || action.menu === AdminPageTypes.VENDA_CAIXA_EXPEDICAO)
                    return state.set('currentPage', AdminPageTypes.VENDA);
                if (action.menu === AdminPageTypes.CAIXA_EXPEDICAO)
                    return state.set('currentPage', AdminPageTypes.CAIXA);
                return state.set('currentPage', '');

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'currentPage')
                    return state.set('currentPage', action.value);
                return state;

            default:
                return state;
        }
    }
}

export default new LojaStore();



// WEBPACK FOOTER //
// src/stores/LojaStore.js